import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { RegulationAcceptanceDto } from '@models/regulation/regulation-acceptance.dto';
import { RegulationDto } from '@models/regulation/regulation.dto';
import { SubscriberDto } from '@models/users/subscriber.dto';

@Injectable({
  providedIn: 'root',
})
export class RegulationService {
  constructor(private http: HttpClient) {}

  getRegulationList() {
    return this.http.get<RegulationDto[]>(
      environment.host + '/regulations/list',
    );
  }

  getAcceptanceRegulationList() {
    return this.http.get<SubscriberDto[]>(
      environment.host + '/regulations/user-list',
    );
  }

  createRegulation(subs: RegulationDto[]) {
    return this.http.post<RegulationDto[]>(
      environment.host + '/regulations/create',
      subs,
    );
  }

  acceptRegulation(subs: RegulationAcceptanceDto[]) {
    return this.http.post<RegulationDto[]>(
      environment.host + '/regulations/accept',
      subs,
    );
  }

  modifyRegulation(subs: RegulationDto[]) {
    return this.http.post<RegulationDto[]>(
      environment.host + '/regulations/modify',
      subs,
    );
  }

  removeRegulation(subs: RegulationDto[]) {
    return this.http.post<RegulationDto[]>(
      environment.host + '/regulations/remove',
      subs,
    );
  }
}
